import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Page from '../../../../components/PageWrapper';
import useRoute from '../../../../hooks/routesHook';
import { useQuery } from '@tanstack/react-query';
import { Expense } from '../../../../models/expense/Expense';
import useModal from '../../../../hooks/modalHook';
import Loader from '../../../../components/Loader';
import { getExpenseById } from '../../../../api/requests';
import moment from 'moment';
import { IExpense } from '../../../../models/expense/IExpense';
import { getFormattedDate } from '../../../../utils/miscFunctions';

const myResponse: any = {
    "id": 162237,
    "title": "Macbook Pro",
    "description": "test purchase",
    "amount": 1080,
    "currency": "USD",
    "attachment": null,
    "dateOfTransaction": "2025-02-27",
    "staff": null,
    "createdOn": "2025-02-27",
    "updatedOn": "2025-02-27"
}
type ExpenseDetailsProps = {
    expense?: IExpense
}
const ExpenseDetails = ({ expense }: ExpenseDetailsProps) => {
    const { getDashboardBase } = useRoute();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const params = useParams();
    const expenseId = params?.id;
    const { ModalComponent, updateModalStates, closeModal } = useModal();

    return (
        <Page title={`Expense ${expenseId}`} className="">
         
                <div className="min-h-full bg-white p-5 rounded-md">
                    <h1 className='text-lg font-bold'>Expense Details</h1>

                    <div className="mt-5">
                        <ExpenseDetailsItem name="Title" value={expense?.title ?? '-'} />
                        <ExpenseDetailsItem name="Description" value={expense?.description ?? '-'} />
                        <ExpenseDetailsItem name="Category" value={expense?.category ?? '-'} />
                        <ExpenseDetailsItem name="Currency" value={expense?.currency ?? '-'} />
                        <ExpenseDetailsItem name="Amount" value={expense?.amount ?? '-'} />
                        <ExpenseDetailsItem name="Date of Transaction" value={expense?.createdOn ? getFormattedDate({ date: expense?.createdOn, showTime: true }) : '-'} />
                        <ExpenseDetailsItem name="Created On" value={expense?.createdOn ? getFormattedDate({ date: expense?.createdOn, showTime: true }) : '-'} />
                    </div>
                </div>
         

            <ModalComponent />
        </Page>
    );
};

export default ExpenseDetails;

type ExpenseDetailsItemProps = {
    name?: string;
    value?: string | number | JSX.Element;
    children?: React.ReactNode;
};

const ExpenseDetailsItem = ({ name, value, children }: ExpenseDetailsItemProps) => {
    return (
        <div className="flex flex-row justify-between py-1 text-sm">
            <div className="text-gray-600 ">{name}:</div>
            <div className="flex gap-1">
                <span className={`truncate font-medium whitespace-nowrap`}>{value}</span>
                <>{children} </>
            </div>
        </div>
    );
};

